<template>
    <div class="relative flex w-full items-center px-2 md:px-0">
        <div ref="container" class="w-0 min-w-full overflow-x-hidden">
            <div
                ref="carousel"
                class="flex snap-x snap-mandatory items-stretch overflow-x-auto py-2"
                :class="isCentered ? 'justify-center' : 'justify-start'"
                @scroll="updateNav"
            >
                <div
                    v-for="product in products"
                    :key="product.slug"
                    class="w-48 flex-none snap-start px-1.5"
                    :class="isDesktop ? 'md:w-64 xl:w-72' : ''"
                >
                    <component
                        :is="card"
                        :product="product"
                        :preview-only="previewOnly"
                        :open-in-new-tab="openInNewTab"
                    >
                        <template #placeholder>
                            <slot name="placeholder" :product="product"></slot>
                        </template>
                    </component>
                </div>
            </div>
        </div>

        <button
            v-if="enableStart"
            type="button"
            aria-label="Anterior"
            class="absolute left-0 z-30 flex h-6 w-6 items-center justify-center rounded-full border border-stack-line bg-theme-card shadow-md"
            :class="isDesktop ? 'md:h-10 md:w-10' : ''"
            @click="goPrev"
        >
            <ChevronLeftIcon
                class="h-4 w-4 text-theme-muted"
                :class="isDesktop ? 'md:h-6 md:w-6' : ''"
            />
        </button>

        <button
            v-if="enableEnd"
            type="button"
            aria-label="Siguiente"
            class="absolute right-0 z-30 flex h-6 w-6 items-center justify-center rounded-full border border-stack-line bg-theme-card shadow-md"
            :class="isDesktop ? 'md:h-10 md:w-10' : ''"
            @click="goNext"
        >
            <ChevronRightIcon
                class="h-4 w-4 text-theme-muted"
                :class="isDesktop ? 'md:h-6 md:w-6' : ''"
            />
        </button>
    </div>
</template>

<script>
import ChevronLeftIcon from "@/components/icons/ChevronLeftIcon.vue";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon.vue";

export default {
    name: "ProductsScrollCarousel",
    components: { ChevronLeftIcon, ChevronRightIcon },
    props: {
        products: { type: Array, required: true },
        card: { type: [String, Object, Function], required: true },
        previewOnly: { type: Boolean, default: false },
        isDesktop: { type: Boolean, default: true },
        openInNewTab: { type: Boolean, default: false }
    },
    data: () => ({
        enableStart: false,
        enableEnd: false,
        isCentered: true
    }),
    watch: {
        products() {
            this.$nextTick(this.updateNav);
        },
        isDesktop() {
            this.$nextTick(this.updateNav);
        }
    },
    mounted() {
        window.addEventListener("resize", this.updateNav);
        this.updateNav();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.updateNav);
    },
    methods: {
        goNext() {
            const carousel = this.$refs.carousel;
            const width = carousel.firstElementChild?.clientWidth || 0;
            carousel.scrollLeft += width;
            this.updateNav();
        },
        goPrev() {
            const carousel = this.$refs.carousel;
            const width = carousel.firstElementChild?.clientWidth || 0;
            carousel.scrollLeft -= width;
            this.updateNav();
        },
        updateNav() {
            const carousel = this.$refs.carousel;
            const container = this.$refs.container;
            if (!carousel || !container || !this.products.length) return;
            const cardWidth = carousel.firstElementChild?.clientWidth || 0;
            this.isCentered =
                cardWidth * this.products.length <= container.clientWidth;
            this.enableStart = !this.isCentered && carousel.scrollLeft > 0;
            this.enableEnd =
                !this.isCentered &&
                carousel.scrollWidth -
                    carousel.scrollLeft -
                    carousel.clientWidth -
                    10 >
                    0;
        }
    }
};
</script>
